var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"t-link"},[(_vm.isExternalLink(_vm.link))?_c('a',{attrs:{"href":_vm.link}},[_vm._t("default")],2):_c('router-link',{attrs:{"to":{ name: _vm.link }}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/ui-components/t-link/index.vue?vue&type=template&id=214d1d67&
// module id = 1353
// module chunks = 0